export default __webpack_public_path__ + "static/media/vid2.b76a567b.png";